import axios from 'axios'

export const commonRequest = async (method,url,body)=>{
    let config = {
        method,
        url,
        data:body,
    }
    return axios(config).then((data)=>{
            return data
        }
    ).catch((err)=>{
            return err
        }   
    )
}